import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-7401ad6e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notificationItem" }
const _hoisted_2 = { class: "indicators" }

import { Ref, ref } from 'vue';

import BrandIcon from '@/components/icons/BrandIcon.vue';
import { Notification } from '@/data/datatypes/Notification';
import NavListItem from '@/navigation/NavListItem.vue';

interface Props {
  notification: Notification;
}
interface Emits {
  (e: 'click', event: MouseEvent): void,
  (e: 'deleted'): void,
}

export default /*#__PURE__*/_defineComponent({
  __name: 'NotificationNavListItem',
  props: {
    notification: {}
  },
  emits: ["click", "deleted"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit;

const deleteButtonFocused: Ref<boolean> = ref(false);

function handleClick(event: MouseEvent): MouseEvent {
  emit('click', event);
  emit('deleted');
  return event;
}

function handleDelete(): void {
  //  Delete activity
  emit('deleted');
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(NavListItem, {
      to: _ctx.notification.route,
      selected: false,
      subtext: _ctx.notification.subtext,
      date: _ctx.notification.timestamp,
      user: _ctx.notification.userIdent,
      name: _ctx.notification.title,
      onClick: handleClick
    }, {
      notification: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(BrandIcon, {
            name: _ctx.notification.icon,
            showFocus: false
          }, null, 8, ["name"]),
          (_ctx.notification.canDelete)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                id: "delete",
                class: "delete",
                title: "Delete",
                onClick: _withModifiers(handleDelete, ["stop","prevent"]),
                onFocusin: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (deleteButtonFocused.value = true), ["self"])),
                onFocusout: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (deleteButtonFocused.value = false), ["self"]))
              }, [
                _createVNode(BrandIcon, {
                  class: "icon deleteIcon",
                  name: "light/delete-light",
                  title: "Dismiss notification",
                  showFocus: deleteButtonFocused.value
                }, null, 8, ["showFocus"])
              ], 32))
            : _createCommentVNode("", true)
        ])
      ]),
      _: 1
    }, 8, ["to", "subtext", "date", "user", "name"])
  ]))
}
}

})